import { render } from "./BuildingCircleIcon.vue?vue&type=template&id=c0b8a75c"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__